import { Box, Button, IconButton, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { InstructionsProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import Slider from 'react-slick';
import InstructionsSlideOne from '../assets/videos/Instruction_1.mp4';
import InstructionsSlideTwo from '../assets/videos/Instruction_2.mp4';
import InstructionsSlideThree from '../assets/videos/Instruction_3.mp4';
import InstructionsSlideFour from '../assets/videos/Instruction_4.mp4';
import { Eclipse } from '../Icons/Eclipse';
import { InstructionsLeftArrow } from '../Icons/InstructionsLeftArrow';
import { InstructionsRightArrow } from '../Icons/InstructionsRightArrow';
import ReactPlayer from 'react-player';
import { dispatchCTAClickObject } from '../Analytics';

export interface InstructionImages {
  text: string;
  textAR: string;
  image: string;
}

const Instructions = ({ activeLocale, active, setActive }: InstructionsProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [slider, setSlider] = useState<any>();
  const [activeImageIndex, setActiveImageIndex] = useState({ oldIndex: 0, newIndex: 0 });

  const Images: InstructionImages[] = [
    {
      text: 'Use the map to navigate between fragrances',
      textAR: 'استخدم الخريطة للتنقل بين العطور بسهولة.',
      image: InstructionsSlideOne,
    },
    {
      text: 'Hold and drag to explore your surroundings',
      textAR: 'اضغط ثم اسحب لتكتشف ما حولك',
      image: InstructionsSlideTwo,
    },
    {
      text: 'Tap on the floor to move',
      textAR: 'اضغط على الأرض لتتحرك',
      image: InstructionsSlideThree,
    },
    {
      text: 'Click on the icons to discover more',
      textAR: 'انقر على الرموز لاكتشاف المزيد',
      image: InstructionsSlideFour,
    },
  ];

  const nextSlide = () => {
    dispatchCTAClickObject('loccitane', 'button', 'instructions', 'next', '');
    slider.slickNext();
  };

  const prevSlide = () => {
    dispatchCTAClickObject('loccitane', 'button', 'instructions', 'prev', '');
    slider.slickPrev();
  };

  const settings = {
    speed: 500,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setActiveImageIndex({ oldIndex: oldIndex, newIndex: newIndex });
    },
  };
  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.5)"
        transition="all 1s"
        zIndex="9"
        onClick={() => {
          setActive();
          setTimeout(() => {
            setActiveImageIndex({ oldIndex: 0, newIndex: 0 });
            slider.slickGoTo(0);
          }, 500);
        }}
      />

      <Box
        zIndex="10"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['80vw', '350px', '400px', '400px', '450px']}
        height={['380px', '460px', '500px', '500px', '550px']}
      >
        <LoccitaneClose
          boxSize={[6, 6, 8]}
          position="absolute"
          top={['25px', '30px', '35px']}
          right={['25px', '30px', '35px']}
          cursor="pointer"
          fill="black"
          strokeWidth={0.5}
          onClick={() => {
            setActive();
            setTimeout(() => {
              setActiveImageIndex({ oldIndex: 0, newIndex: 0 });
              slider.slickGoTo(0);
            }, 500);
          }}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
        />

        <Box
          border="5px solid #FFCB00"
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          height="100%"
        >
          <Box
            width={['100%', '100%', '100%', '100%', '100%']}
            display="flex"
            flexDirection={['column', 'column', 'column', 'column', 'column']}
            position="relative"
          >
            <Box
              className="instructions-slider"
              width={['100%', '100%', '100%', '100%', '100%']}
              h={['180px', '250px', '300px', '300px', '300px']}
              textAlign="center"
              marginBottom={['10px']}
            >
              <Slider ref={(slider) => setSlider(slider)} {...settings}>
                {Images?.map((image: InstructionImages, index: number) => (
                  <ReactPlayer
                    key={index}
                    id="instructions-screen-video"
                    height="100%"
                    width="100%"
                    // style={{ minHeight: '100vh' }}
                    loop={true}
                    muted
                    controls={false}
                    playing={true}
                    url={image.image}
                    playsinline
                  />
                ))}
              </Slider>
            </Box>
          </Box>
          <Box
            display={['flex', 'flex', 'flex', 'flex', 'flex']}
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            h="auto"
          >
            {Images.map((image: InstructionImages, index: number) => (
              <Eclipse
                borderRadius="100%"
                key={image.image}
                m="0px 5px"
                boxSize={[2, 2, 3]}
                strokeWidth="2"
                stroke={activeImageIndex.newIndex === index ? '#FFD220' : '#D9D9D9'}
                fill={activeImageIndex.newIndex === index ? '#FFD220' : 'white'}
                onClick={() => {
                  slider.slickGoTo(index);
                }}
                cursor="pointer"
              />
            ))}
          </Box>
          <Text
            fontSize={['12px', '12px', '15px', '15px', '15px']}
            height={['40px', '40px', '40px', '40px', '40px']}
            width={['90%', '90%', '90%', '90%', '90%']}
            textAlign="center"
            fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'RalewayMedium'}
            marginBottom={['10px']}
          >
            {activeLocale === 'ar' ? Images[activeImageIndex.newIndex].textAR : Images[activeImageIndex.newIndex].text}
          </Text>
          <Box
            w={['150px', '170px', '170px', '170px', '170px']}
            mb={['20px']}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <IconButton
              variant="outline"
              aria-label="Move Left"
              onClick={prevSlide}
              height={['30px', '40px', '40px', '40px', '40px']}
              width={['70px', '80px', '80px', '80px', '80px']}
              borderRadius="0px"
              icon={<InstructionsLeftArrow boxSize={[6, 8, 10]} />}
            />
            {activeImageIndex.newIndex === Images.length - 1 ? (
              <Button
                fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'RalewayMedium'}
                fontSize={['12px', '12px', '15px', '15px', '15px']}
                bg="#FFCB00"
                _hover={{ bg: 'rgb(255, 203, 0, 0.4)', _disabled: { bg: 'lightgrey', cursor: 'auto' } }}
                color="black"
                borderRadius="0px"
                height={['30px', '40px', '40px', '40px', '40px']}
                width={['70px', '80px', '80px', '80px', '80px']}
                onClick={() => {
                  setActive();
                  setTimeout(() => {
                    setActiveImageIndex({ oldIndex: 0, newIndex: 0 });
                    slider.slickGoTo(0);
                  }, 500);
                }}
              >
                {activeLocale === 'ar' ? 'يغلق' : 'Close'}
              </Button>
            ) : (
              <IconButton
                variant="outline"
                aria-label="Move Left"
                onClick={nextSlide}
                height={['30px', '40px', '40px', '40px', '40px']}
                width={['70px', '80px', '80px', '80px', '80px']}
                borderRadius="0px"
                icon={<InstructionsRightArrow boxSize={[6, 8, 10]} />}
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default Instructions;
